module.exports = new __parcel__URL__("access-banner-actions-skeleton.tpl.1ea4a10a.svg").toString();